import {FETCH_COMPANIES_REQUEST, FETCH_COMPANIES_SUCCES, FETCH_COMPANIES_ERROR} from '../constants/Companies'

const initialState = {
  list: {},
  hasErrored: false,
  isLoading: false
}

export default function companies(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMPANIES_REQUEST:
      return {...state, isLoading: true};
    case FETCH_COMPANIES_SUCCES:
      return {...state, list: action.payload.results, isLoading: false};
    case FETCH_COMPANIES_ERROR:
      return {...state, hasErrored: true, isLoading: false};
    default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/companies.js